import rootReducer from './combineReducers';
import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga'

const sagaMiddleware = createSagaMiddleware()
export interface RootState {
 
}
const INITIAL_STATE: RootState = {
  charities: {},
  campaigns: {},
};

const middleware = [thunk, sagaMiddleware];
const composeEnhancers = composeWithDevTools(applyMiddleware(...middleware));
const store = createStore(
  rootReducer,
  INITIAL_STATE,
  composeEnhancers,
);

store.runSaga = sagaMiddleware.run;

export default function configureStore() {
  return store
}

